module.exports = __webpack_public_path__ + "static/media/Kitabisa_Blue_Square.6b197db2.png";